const DEFAULT_PATH = "/library";

export function safePostLoginPath(next) {
  if (next == null) {
    return DEFAULT_PATH;
  }

  let value = String(next).trim();
  try {
    value = decodeURIComponent(value);
  } catch {
    return DEFAULT_PATH;
  }

  if (!value.startsWith("/") || value.startsWith("//") || value.includes("://")) {
    return DEFAULT_PATH;
  }

  const path = value.split("?")[0].split("#")[0];
  if (!path || path === "/") {
    return DEFAULT_PATH;
  }

  if (!/^\/[A-Za-z0-9/_-]+$/.test(path)) {
    return DEFAULT_PATH;
  }

  return path;
}

export function loginPathWithNext(pathname) {
  const raw = String(pathname || "").split("?")[0];
  if (!raw || raw === "/") {
    return "/";
  }

  const next = safePostLoginPath(raw);
  if (next === DEFAULT_PATH && raw !== DEFAULT_PATH) {
    return "/";
  }

  return `/?next=${encodeURIComponent(next)}`;
}

export function postLoginLabel(path) {
  const next = safePostLoginPath(path);
  const segments = next.split("/").filter(Boolean);
  if (segments.length === 2 && next !== "/collection/pdf") {
    const [vendor, slug] = segments;
    return `${vendor} / ${slug.replaceAll("-", " ")}`;
  }
  if (next === "/collection") {
    return "your collection";
  }
  if (next === "/collection/pdf") {
    return "your PDF";
  }
  return null;
}
